<template>
  <div class="transfer-event">
    <panel-head title="转化事件管理" subtitle="OPERATION LOGS"></panel-head>
    <div class="panel-content">
      <h3 class="panel-content__title">
        <span>转化事件管理</span>
        <el-link class="fr"  type="primary" href="https://ad-call.dev.tagtic.cn/docs/docsify/#/conversion">转化事件对接文档</el-link>
      </h3>
      <div class="panel-content__select-wrap">
        <div class="panel-content__select-list">
          <div class="panel-content__select-item">
            <ny-date-range v-model="date" format="yyyy-MM-dd" @change="dateChange" :shortcut="true" ></ny-date-range>
          </div>
        </div>
        <div class="panel-content__select-list">
          <div class="panel-content__select-item" v-if="platform==='agency'">
            <span class="panel-content__label">广告主</span>
            <up-select :data="adUsers" filterable multiple collapse-tags v-model="transferEvent.search.advertiser_id">
              <template slot="up:item" slot-scope="{ item, $index }">
                <span>{{ item.name }}</span>
              </template>
            </up-select>
          </div>
          <div class="panel-content__select-item">
            <span class="panel-content__label">计划</span>
            <up-select :data="globalAllAdSelect"  multiple filterable collapse-tags :key-value="['ad_name', 'id']" v-model="transferEvent.search.ad_id">
              <template slot="up:item" slot-scope="{ item, $index }">
                <span>{{ item.ad_name }}({{item.id}})</span>
              </template>
            </up-select>
          </div>
          <div class="panel-content__select-item">
            <span class="panel-content__label">创意</span>
            <up-select :data="globalAllCreativeSelect"  multiple filterable collapse-tags :key-value="['creative_name', 'id']" v-model="transferEvent.search.creative_id">
              <template slot="up:item" slot-scope="{ item, $index }">
                <span>{{ item.creative_name }}({{item.id}})</span>
              </template>
            </up-select>
          </div>
          <div class="panel-content__select-item">
            <span class="panel-content__label">事件</span>
            <up-select :data="transferEventSelect"  multiple filterable collapse-tags v-model="transferEvent.search.event_type">
              <template slot="up:item" slot-scope="{ item, $index }">
                <span>{{ item.name }}({{item.value}})</span>
              </template>
            </up-select>
          </div>
          <div class="panel-content__select-item">
            <el-button  @click="handleSearch">查询</el-button>
          </div>
        </div>
        <div class="panel-content__select-list">
          <div class="panel-content__select-item transfer-event__dimensions">
            <span class="panel-content__label">维度</span>
            <up-checkbox-group :data="dimensionsSelect" v-model="transferEvent.search.dimensions" @change="handleSearch"></up-checkbox-group>
          </div>
        </div>
      </div>
      <div class="panel-content__table-wrap">
        <up-table
          :page="transferEvent.page"
          pagination
          @current-change="handlePageChange"
          @size-change="handlePageChange"
        ></up-table>
      </div>
    </div>
  </div>
</template>
<script>
import { PanelHead, NyDateRange } from '@/global/components'
import Page from '@/global/util/Page'
import { mapActions,mapState } from 'vuex'
import { formatDate } from '@/global/util/date'
export default {
  components: {
    PanelHead,
    NyDateRange
  },
  data () {
    return {
      date: [
        formatDate(new Date()),
        formatDate(new Date())
      ],
      page: new Page(),
      platform: undefined,
      adUsers: []
    }
  },
  computed: {
    ...mapState('transferEvent', ['globalAllAdSelect', 'globalAllCreativeSelect', 'transferEvent', 'transferEventSelect', 'dimensionsSelect']),
  },
  created () {
    this.platform = this.$route.meta.platform
    if(this.platform === 'agency') {
      this._getAdUsers()
    }
    this.getALLAdSelect({
        platform: this.platform
      })
    this.getALLCreativeSelect({
      platform: this.platform
    })
    this.getTransferEventSelect()
    this.init()
  },
  methods: {
    ...mapActions('transferEvent', ['getListData', 'getALLAdSelect', 'getALLCreativeSelect', 'getTransferEventSelect']),
    ...mapActions('group', ['getAdUsers']),
    async init () {
      this._getListData()
    },
    async _getAdUsers () {
      const [err, res] = await this.getAdUsers({ platform: this.platform })
      if (err || res.code !== 1) this.$message.error('获取广告主列表失败')
      else {
        this.adUsers = res.code === 1 ? res.data : []
      }
    },
    async _getListData ({ pageSize, currentPage } = {}) {
      await this.getListData({
        params: {
          platform: this.platform,
          start_time: this.date.length > 1 ? this.date[0] : '',
          end_time: this.date.length > 1 ? this.date[1] : '',
          ...this.transferEvent.search
        },
        pageSize,
        page: currentPage
      })
    },
    handleSearch () {
      this.transferEvent.page.pageSize = 10
      this.transferEvent.page.currentPage = 1
      this._getListData()
    },
    dateChange () {
    },
    handlePageChange ({ currentPage, pageSize }) {
      this._getListData({ currentPage, pageSize })
    }
  }
}
</script>
<style lang="scss">
@include b(transfer-event) {
  .ny-date-range {
    display: inline-block;
  }
  .el-table__row {
    .cell {
      img {
        width: 100%;
        height: auto;
      }
    }
  }
  @include e(dimensions) {
    display: flex;
    align-items: center;
  }
  .el-tag {
    display: flex;
    align-items: center;
  }
.el-select__tags {
  flex-direction: row;
  &>span{
    display: flex;
    width: 90%;
  }
}
  .el-select__tags-text{
    max-width: 90px;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
